import "antd/dist/reset.css";
import { QueryClient, QueryClientProvider } from "react-query";
import LayoutProvider from "./context/LayoutContext";
import { CustomRoutes } from "./routes";
import { useEffect, useMemo, useState } from "react";
import { ConfigProvider } from "antd";
import {
    getAppTheme,
    getCssVariables,
    THEME_STORAGE_KEY,
    themeModes,
} from "./theme";
import { ThemeProvider } from "./context/ThemeContext";

const queryClient = new QueryClient();

function App() {
    const [themeMode, setThemeMode] = useState(() => {
        const savedTheme = localStorage.getItem(THEME_STORAGE_KEY);
        return Object.values(themeModes).includes(savedTheme)
            ? savedTheme
            : themeModes.light;
    });
    const appTheme = useMemo(() => getAppTheme(themeMode), [themeMode]);

    useEffect(() => {
        const handleRefresh = () => {
            localStorage.removeItem("page_reloaded");
        };
        window.addEventListener("beforeunload", handleRefresh);
        return () => {
            window.removeEventListener("beforeunload", handleRefresh);
        };
    }, []);

    useEffect(() => {
        localStorage.setItem(THEME_STORAGE_KEY, themeMode);
        document.documentElement.setAttribute("data-theme", themeMode);

        Object.entries(getCssVariables(themeMode)).forEach(([name, value]) => {
            document.documentElement.style.setProperty(name, value);
        });
    }, [themeMode]);

    return (
        <ConfigProvider
            theme={appTheme}
            getPopupContainer={(node) => {
                // Find the closest scrollable parent or use the content area
                if (node) {
                    let parent = node.parentElement;
                    while (parent) {
                        if (
                            parent.classList.contains("site-layout-background")
                        ) {
                            return parent;
                        }
                        parent = parent.parentElement;
                    }
                }
                return document.body;
            }}
        >
            <QueryClientProvider client={queryClient}>
                <ThemeProvider mode={themeMode} setMode={setThemeMode}>
                    <LayoutProvider>
                        <CustomRoutes />
                    </LayoutProvider>
                </ThemeProvider>
            </QueryClientProvider>
        </ConfigProvider>
    );
}

export default App;
export { queryClient };
